function updateWrapperClass(swiper) {
    const slides = swiper.slides.length;
  
    const swiperWrapper = swiper.wrapperEl; 
  
    // Add or remove class based on slide count being less than 6
    if (slides < 6) {
      swiperWrapper.classList.add('center-justify');
    } else {
      swiperWrapper.classList.remove('center-justify');
    }
}

/* Product Swiper */
var swiper = new Swiper(".productSwiper", {
    slidesPerView: "auto",
    spaceBetween: 32,
    loop: true,
    pagination: {
        el: ".swiper-pagination-nav",
        type: "fraction",
    },
    navigation: {
        nextEl: ".productSwiperNext",
        prevEl: ".productSwiperPrev",
    },
    on: {
        init: function () {
            updateWrapperClass(this); // Update wrapper class on initialization
        },
        resize: function () {
            updateWrapperClass(this); // Re-check and update wrapper class on resize
        }
    }
});




/* Family Swiper */
var swiper = new Swiper(".familySwiper", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });

/* Full Image Swiper */
 var swiper = new Swiper(".fullImageSwiper", {
      loop:true,
       speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: ".swiper-pagination-nav",
        type: "fraction",
      },
   navigation: {
        nextEl: ".fullSwiperNext",
        prevEl: ".fullSwiperPrev",
      },
    });
  

/* Team Swiper */
var swiper = new Swiper(".teamSwiper", {
    slidesPerView: "auto",
    spaceBetween: 32,
    loop:true,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".teamSwiperNext",
        prevEl: ".teamSwiperPrev",
      },
});

/* Fullscreen Swiper */
var swiper = new Swiper(".fullScreenSwiper", {
  autoHeight: true,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".fullScreenSwiperNext",
        prevEl: ".fullScreenSwiperPrev",
      },
});

/* Gallery Swiper */
var swiper = new Swiper(".gallerySwiper", {
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".gallerySwiperNext",
        prevEl: ".gallerySwiperPrev",
      },
    breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
        1171: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
});

document.addEventListener('DOMContentLoaded', function () {

  var processSwiper = new Swiper(".processSwiper", {
    slidesPerView: 1.2,
    spaceBetween: 32,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,

    navigation: {
      nextEl: ".processSwiperNext",
      prevEl: ".processSwiperPrev",
    },

    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 32,
      },
      1171: {
        slidesPerView: 4.2,
        spaceBetween: 32,
      },
    },
  });

function updateProcessFraction() {
  const pagination = document.querySelector('.process-pagination');

  if (!pagination) return;

  const current = processSwiper.realIndex + 1;
  const total = processSwiper.slides.length;

  pagination.innerHTML = `
    <span>${current}</span>
    /
    <span>${total}</span>
  `;
}

  setTimeout(() => {
    updateProcessFraction();
  }, 100);

  processSwiper.on('slideChange', updateProcessFraction);
  processSwiper.on('resize', updateProcessFraction);

});

/* Images Swiper */
document.addEventListener('DOMContentLoaded', function () {
  var splitImagesSwiper = new Swiper(".splitImagesSwiper", {
    slidesPerView: 1,
    spaceBetween: 32,

    navigation: {
      nextEl: ".splitImagesNext",
      prevEl: ".splitImagesPrev",
    },

    breakpoints: {
      769: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
    },
  });

function updateSplitImagesFraction() {
  var pagination = document.querySelector('.split-images-pagination');
  var nav = document.querySelector('.split-images-nav');

  if (!pagination || !nav) return;

  var totalSlides = splitImagesSwiper.slides.length;
  var slidesPerView = window.innerWidth >= 769 ? 2 : 1;
  var total = Math.max(1, totalSlides - slidesPerView + 1);
  var current = Math.min(splitImagesSwiper.realIndex + 1, total);

  if (total <= 1) {
    nav.style.display = 'none';
    return;
  }

  nav.style.display = 'flex';
  pagination.innerHTML = current + '/' + total;
}

  setTimeout(function () {
    updateSplitImagesFraction();
  }, 100);

  splitImagesSwiper.on('slideChange', updateSplitImagesFraction);
  splitImagesSwiper.on('resize', updateSplitImagesFraction);
});

/* Author Swiper */
var swiper = new Swiper(".authorSwiper", {
    slidesPerView: 1,
    spaceBetween: 32,
});

/* Testimonials Swiper */
var swiper = new Swiper(".testimonialSwiper", {
    slidesPerView: 1,
    spaceBetween: 32,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".testimonialSwiperNext",
        prevEl: ".testimonialSwiperPrev",
      },
});

/* 3 Cols Swiper */
var swiper = new Swiper(".SwiperCols", {
      slidesPerView: 1,
      spaceBetween: 32,
      pagination: {
      el: ".swiper-pagination-nav",
      type: "fraction",
    },
   navigation: {
        nextEl: ".colSwiperNext",
        prevEl: ".colSwiperPrev",
      },
  breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
        1171: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });




// Thumbnail Swiper
var swiper = new Swiper(".thumbnailSwiper", {
  direction: 'vertical',
  slidesPerView: 4,   // 4 full + half of the next
  spaceBetween: 8,      // 8px gap between slides
  freeMode: true,
  watchSlidesProgress: true,
  autoHeight: true,    // keep height fixed so thumbs stay square
});

// Main Swiper
var swiper2 = new Swiper(".productMobileSwiper", {
  spaceBetween: 8,
  loop: true,
  pagination: {
      el: ".swiper-pagination-nav-mobile",
      type: "fraction",
  },
  navigation: {
    nextEl: ".productSwiperNextMobile",
    prevEl: ".productSwiperPrevMobile",
  },
  thumbs: { swiper: swiper },
});



/* product images swiper !!MUST BE AT END OF SCRIPT FILE!! WHO KNOWS WHY?? \o/ */
var swiper = new Swiper('.mediaSwiper ', {
  loop: true,
  spaceBetween: 32,
  pagination: {
        el: ".swiper-pagination-nav",
        type: "fraction",
      },
   navigation: {
        nextEl: ".productSwiperNext",
        prevEl: ".productSwiperPrev",
      },
});

var cartUpsells = new Swiper(".cn-upsells", { slidesPerView: 1.1, spaceBetween: 12, navigation: { nextEl: ".swiper-button-next.cn", prevEl: ".swiper-button-prev.cn", }, });

var cartUpsellsc = new Swiper(".cn-upsells-cart", {
  spaceBetween: 12,

  // mobile first
  slidesPerView: 1,

  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },

  navigation: {
    nextEl: ".swiper-button-next.cnc",
    prevEl: ".swiper-button-prev.cnc",
  },
});

